import { ApiCore } from "./ApiCoreService";

const API_URL = process.env.REACT_APP_API_URL;

/* ----------------------------- AUTH SERVICES ----------------------------- */

export function login(body) {
  let url = `${API_URL}/auth/login`;
  return new ApiCore().post(url, body);
}

export function logout() {
  let url = `${API_URL}/auth/logout`;
  return new ApiCore().postAuth(url);
}

export function forgetpassword(body) {
  let url = `${API_URL}/auth/forgot-password`;
  return new ApiCore().post(url, body);
}

export function resetPassword(body) {
  let url = `${API_URL}/auth/reset-password`;
  return new ApiCore().post(url, body);
}

export function changePassword(body) {
  let url = `${API_URL}/auth/change-password`;
  return new ApiCore().postAuth(url, body);
}

/* ----------------------------- OTP SERVICES ------------------------------ */

export function sendOtp(body) {
  let url = `${API_URL}/api/send-otp`;
  return new ApiCore().post(url, body);
}

export function verifyFactorOtp(body) {
  let url = `${API_URL}/api/verify-factor-otp`;
  return new ApiCore().post(url, body);
}

export function otpVerify(body) {
  let url = `${API_URL}/api/verify-otp`;
  return new ApiCore().post(url, body);
}

/* ---------------------------- FORM SERVICES ------------------------------ */

export function getFormStruc(body) {
  let url = `${API_URL}/api/onboard-form`;
  return new ApiCore().postAuth(url, body);
}

export function getFormData(id) {
  let url = `${API_URL}/api/get-onboard-form?id=${id}`;
  return new ApiCore().getAuth(url);
}

export function SubmitForm(body) {
  let url = `${API_URL}/api/submit-onboard-form`;
  return new ApiCore().postforFormData(url, body);
}

export function UpdateRequest(body) {
  let url = `${API_URL}/api/edit-onboard-form`;
  return new ApiCore().postforFormData(url, body);
}

export function getAllRequest(page, pageSize, id, filters, download) {
  let url = `${API_URL}/api/get-onboard-form-list?all=${
    id ? 0 : 1
  }&page=${page}&per_page=${pageSize}`;

  if (id) url += `&emp_id=${id}`;

  if (download) {
    url += "&is_download=true";
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length) url += `&${key}=${value.join(",")}`;
    } else if (value) {
      url += `&${key}=${value}`;
    }
  });

  return new ApiCore().getAuth(url);
}

export function getDirectoryFilterOptions(clientIds = [], customerIds = []) {
  const params = [];
  if (clientIds.length)
    params.push(`client_ids=${clientIds.map(encodeURIComponent).join(",")}`);
  if (customerIds.length)
    params.push(`customer_ids=${customerIds.map(encodeURIComponent).join(",")}`);
  const url = `${API_URL}/api/directory-filter-options${
    params.length ? "?" + params.join("&") : ""
  }`;
  return new ApiCore().getAuth(url);
}

// limit/offset/filter are optional: with a limit the server returns just that slice
// (the Home page list scrolls in 20 at a time); without one it returns everything.
export function getDashboardEvents(days = 30, includeFuture = false, paging = {}) {
  let url = `${API_URL}/api/dashboard-upcoming-events?days=${days}&include_future=${includeFuture}`;
  if (paging.limit) url += `&limit=${paging.limit}&offset=${paging.offset || 0}`;
  if (paging.filter) url += `&filter=${encodeURIComponent(paging.filter)}`;
  return new ApiCore().getAuth(url);
}

export function getRequestCount(id) {
  let url = `${API_URL}/api/get-onboard-count?all=1`;
  if (id) url = `${API_URL}/api/get-onboard-count?all=0&emp_id=${id}`;
  return new ApiCore().getAuth(url);
}

export function ChangeStatus(body) {
  let url = `${API_URL}/api/update-status`;
  return new ApiCore().postAuth(url, body);
}

export function DeleteReq(body) {
  let url = `${API_URL}/api/delete-onboard-form`;
  return new ApiCore().postAuth(url, body);
}

// Admin-only "Deactivate" on the Directory table -- replaces DeleteReq
// above (a permanent hard delete, no longer wired to any UI) with a
// reversible soft-delete flag flip. Confirmed with the user, 2026-10-27.
export function SoftDeleteReq(body) {
  let url = `${API_URL}/api/soft-delete-onboard-form`;
  return new ApiCore().postAuth(url, body);
}

/* ------------------------- CLIENT FORM SERVICES -------------------------- */

export function getClientFormStruc() {
  let url = `${API_URL}/api/client-onboard-form`;
  return new ApiCore().getAuth(url);
}

export function UploadBulkData(body, isClientUpload) {
  let url = `${API_URL}/api/bulk_upload?user_type=2`;
  if (isClientUpload) url = `${API_URL}/api/bulk_upload?user_type=1`;
  return new ApiCore().postforFormData(url, body);
}

export function UploadBulkUpdate(body) {
  let url = `${API_URL}/api/bulk_update`;
  return new ApiCore().postforFormData(url, body);
}

export function getClientFormData(id) {
  let url = `${API_URL}/api/client-formdata?id=${id}`;
  return new ApiCore().getAuth(url);
}

export function SubmitClientForm(body) {
  let url = `${API_URL}/api/submit-client-data`;
  return new ApiCore().postforFormData(url, body);
}

export function UpdateClientRequest(body) {
  let url = `${API_URL}/api/update-client-data`;
  return new ApiCore().postforFormData(url, body);
}

export function extractClientDocument(body) {
  let url = `${API_URL}/api/extract-client-document`;
  return new ApiCore().postforFormData(url, body);
}

export function getClientAttachments(clientId) {
  let url = `${API_URL}/api/get-client-attachments/${clientId}`;
  return new ApiCore().getAuth(url);
}

export function getAllClient(page, pageSize, filters, download) {
  let url = `${API_URL}/api/get-client-data?page=${page}&per_page=${pageSize}`;

  if (download) {
    url += "&is_download=true";
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) url += `&${key}=${value}`;
  });

  return new ApiCore().getAuth(url);
}

export function DeleteClientReq(body) {
  let url = `${API_URL}/api/delete-client-req`;
  return new ApiCore().postAuth(url, body);
}

export function getAllRecords(page, pageSize, filters, download) {
  let url = `${API_URL}/api/get-merged-client-employee-data?page=${page}&per_page=${pageSize}`;

  if (download) {
    url += "&is_download=true";
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) url += `&${key}=${value}`;
  });

  return new ApiCore().getAuth(url);
}

export function ClientDropdownData() {
  let url = `${API_URL}/api/client-dropdown`;
  return new ApiCore().getAuth(url);
}

/* ----------------------------- REPORTS ----------------------------- */

export function getStandardReports() {
  let url = `${API_URL}/api/get-standard-reports`;
  return new ApiCore().getAuth(url);
}

export function getReportFilterCountries(clientId) {
  let url = `${API_URL}/api/get-report-filter-countries`;
  if (clientId) url += `?client_id=${encodeURIComponent(clientId)}`;
  return new ApiCore().getAuth(url);
}

// Returns a Blob (the generated .xlsx) via postAuthBlob -- the caller is
// responsible for checking the Blob's type before treating it as a real
// file (an error response still comes back as JSON, just wrapped in a
// Blob because of responseType: "blob").
export function generateReport(reportType, filters) {
  let url = `${API_URL}/api/generate-report`;
  return new ApiCore().postAuthBlob(url, { report_type: reportType, filters });
}

// Returns a Blob (the generated .mcl) via postFormDataBlob -- same
// caveat as generateReport above, an error response still comes back as
// JSON wrapped in a Blob because of responseType: "blob".
export function generateMclFile(formData) {
  let url = `${API_URL}/api/generate-mcl`;
  return new ApiCore().postFormDataBlob(url, formData);
}

export function saveReport(name, reportType, filters) {
  let url = `${API_URL}/api/save-report`;
  return new ApiCore().postAuth(url, { name, report_type: reportType, filters });
}

export function getSavedReports() {
  let url = `${API_URL}/api/get-saved-reports`;
  return new ApiCore().getAuth(url);
}

export function deleteSavedReport(id) {
  let url = `${API_URL}/api/delete-saved-report?id=${id}`;
  return new ApiCore().postAuth(url, {});
}

/* ------------------------- SERVICES FEE -------------------------- */

export function getClientCutomerData() {
  let url = `${API_URL}/api/get-client-customer-data`;
  return new ApiCore().getAuth(url);
}

export function getClientCutomerDataById(clientId, id) {
  let url = `${API_URL}/api/get-client-customer-byid?client_id=${clientId}&client_customer_id=${id}`;
  return new ApiCore().getAuth(url);
}

export function updateClientCutomerData(id, body) {
  let url = `${API_URL}/api/update-client-customer-data?id=${id}`;
  return new ApiCore().postforFormData(url, body);
}

// Backs the account-owner reassignment confirmation modal (Customer List
// page) -- every employee under this customer, with their current status
// and resolved owner, so the user can pick exactly which ones move to a
// newly-picked owner rather than the customer-level label silently
// drifting from the real per-employee assignments.
export function getCustomerEmployeesForOwnerChange(clientCustomerId) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/employees-for-owner-change`;
  return new ApiCore().getAuth(url);
}

export function reassignClientCustomerAccountOwner(clientCustomerId, body) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/reassign-account-owner`;
  return new ApiCore().postAuth(url, body);
}

// Client-level "Change Account Owner" -- cascades a new owner across
// every selected customer under a client, all their non-exited
// employees, and any existing per-country owner overrides. Confirmed
// with the user, 2026-10-22.
export function getClientCustomersForOwnerChange(clientId) {
  let url = `${API_URL}/api/clients/${clientId}/customers-for-owner-change`;
  return new ApiCore().getAuth(url);
}

export function reassignClientAccountOwner(clientId, body) {
  let url = `${API_URL}/api/clients/${clientId}/reassign-account-owner`;
  return new ApiCore().postAuth(url, body);
}

// One row per (customer, country) pair across every customer under this
// client -- backs the Client Update Form's "Account Owners by Country"
// table. Reassigning itself reuses the existing customer+country
// endpoints (reassignCustomerCountryAccountOwner / unassign), this just
// lists them all in one place. Confirmed with the user, 2026-10-26.
export function getClientAccountOwnersByCountry(clientId) {
  let url = `${API_URL}/api/clients/${clientId}/account-owners-by-country`;
  return new ApiCore().getAuth(url);
}

// Country-wise customer fees/owner -- per-country override one level
// down from the client-level country fees (see models/
// client_customer_country_fee.py and client_customer_country_owner.py).
export function getCustomerCountriesWithEmployees(clientCustomerId) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/countries-with-employees`;
  return new ApiCore().getAuth(url);
}

export function getCustomerCountryOverview(clientCustomerId) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/country-overview`;
  return new ApiCore().getAuth(url);
}

export function upsertCustomerCountryFee(clientCustomerId, countryId, body) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/country-fees/${countryId}`;
  return new ApiCore().postAuth(url, body);
}

export function deleteCustomerCountryFee(clientCustomerId, countryId) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/country-fees/${countryId}/delete`;
  return new ApiCore().postAuth(url, {});
}

export function getCustomerCountryEmployeesForOwnerChange(clientCustomerId, countryId) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/country/${countryId}/employees-for-owner-change`;
  return new ApiCore().getAuth(url);
}

export function reassignCustomerCountryAccountOwner(clientCustomerId, countryId, body) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/country/${countryId}/reassign-account-owner`;
  return new ApiCore().postAuth(url, body);
}

export function unassignCustomerCountryAccountOwner(clientCustomerId, countryId) {
  let url = `${API_URL}/api/client-customer/${clientCustomerId}/country/${countryId}/unassign-account-owner`;
  return new ApiCore().postAuth(url, {});
}

export function getClientCustomerAttachments(id) {
  let url = `${API_URL}/api/get-client-customer-attachments/${id}`;
  return new ApiCore().getAuth(url);
}

export function addClientCutomerData(body) {
  let url = `${API_URL}/api/add-client-customer`;
  return new ApiCore().postAuth(url, body);
}

/* ----------------------- USER MANAGEMENT SERVICES ------------------------ */

export function getUserById(id) {
  let url = `${API_URL}/api/get-user-by-id?id=${id}`;
  return new ApiCore().getAuth(url);
}

export function updateUser(body) {
  let url = `${API_URL}/api/update-user`;
  return new ApiCore().postforFormData(url, body);
}

export function addUser(body) {
  let url = `${API_URL}/api/add-user`;
  return new ApiCore().postforFormData(url, body);
}

export function getAllUsersAdmin() {
  let url = `${API_URL}/api/get-all-users?all=1`;
  return new ApiCore().getAuth(url);
}

export function updateUserRole(body) {
  let url = `${API_URL}/api/update-user-role`;
  return new ApiCore().postAuth(url, body);
}

export function updateUserManager(body) {
  let url = `${API_URL}/api/update-user-manager`;
  return new ApiCore().postAuth(url, body);
}

export function getUserHierarchy(employeeId) {
  let url = `${API_URL}/api/get-user-hierarchy?employee_id=${encodeURIComponent(employeeId)}`;
  return new ApiCore().getAuth(url);
}

export function deleteUser(id) {
  let url = `${API_URL}/api/delete-user?id=${id}`;
  return new ApiCore().postAuth(url);
}

export function reShowUser(id) {
  let url = `${API_URL}/api/re-show-user?id=${id}`;
  return new ApiCore().postAuth(url);
}

/* ----------------------- ROLE & PERMISSION SERVICES ----------------------- */

export function getMyPermissions() {
  let url = `${API_URL}/api/my-permissions`;
  return new ApiCore().getAuth(url);
}

export function createRole(body) {
  let url = `${API_URL}/api/add-role`;
  return new ApiCore().postAuth(url, body);
}

export function getAllRoles() {
  let url = `${API_URL}/api/get-all-roles`;
  return new ApiCore().getAuth(url);
}

export function getRoleById(id) {
  let url = `${API_URL}/api/get-role-by-id?id=${id}`;
  return new ApiCore().getAuth(url);
}

export function updateRolePermissions(body) {
  let url = `${API_URL}/api/update-role-permissions`;
  return new ApiCore().postAuth(url, body);
}

export function deleteRole(id) {
  let url = `${API_URL}/api/delete-role?id=${id}`;
  return new ApiCore().postAuth(url);
}

/* ------------------------- MASTER DATA SERVICES -------------------------- */

export function getAllFields() {
  let url = `${API_URL}/api/get-all-field`;
  return new ApiCore().getAuth(url);
}

export function AddField(body) {
  let url = `${API_URL}/api/create-field`;
  return new ApiCore().postAuth(url, body);
}

export function UpdateField(body) {
  let url = `${API_URL}/api/update-field`;
  return new ApiCore().postAuth(url, body);
}

export function DeleteField(id) {
  let url = `${API_URL}/api/delete-field?id=${id}`;
  return new ApiCore().postAuth(url);
}

export function getProclozBillingEntityDropdown() {
  let url = `${API_URL}/api/procloz-billing-entity-dropdown`;
  return new ApiCore().getAuth(url);
}

export function addProclozBillingEntity(body) {
  let url = `${API_URL}/api/add-procloz-billing-entity`;
  return new ApiCore().postAuth(url, body);
}

export function getCurrencyDropdown() {
  let url = `${API_URL}/api/currency-dropdown`;
  return new ApiCore().getAuth(url);
}

export function getAllCountries(added) {
  if (added == undefined || added == null) {
    added = 0
  }
  let url = `${API_URL}/api/get-all-country?added=${added}`;
  return new ApiCore().getAuth(url);
}

// Country-wise Client Fees -- per-country override of a client's fee
// fields (see models/client_country_fee.py). client_form's own fee
// fields stay the default for a single-country client.
export function getClientCountryFees(clientId) {
  let url = `${API_URL}/api/clients/${clientId}/country-fees`;
  return new ApiCore().getAuth(url);
}

export function addClientCountryFee(clientId, body) {
  let url = `${API_URL}/api/clients/${clientId}/country-fees`;
  return new ApiCore().postAuth(url, body);
}

export function updateClientCountryFee(clientId, feeId, body) {
  let url = `${API_URL}/api/clients/${clientId}/country-fees/${feeId}/update`;
  return new ApiCore().postAuth(url, body);
}

export function deleteClientCountryFee(clientId, feeId) {
  let url = `${API_URL}/api/clients/${clientId}/country-fees/${feeId}/delete`;
  return new ApiCore().postAuth(url, {});
}

export function AddCountry(body) {
  let url = `${API_URL}/api/add-country`;
  return new ApiCore().postAuth(url, body);
}

export function UpdateCountry(body) {
  let url = `${API_URL}/api/update-country`;
  return new ApiCore().postAuth(url, body);
}

export function DeleteCountry(id) {
  let url = `${API_URL}/api/delete-country?id=${id}`;
  return new ApiCore().postAuth(url);
}

export function getCountryById(id) {
  let url = `${API_URL}/api/get-country?id=${id}`;
  return new ApiCore().getAuth(url);
}

/* ---------------------------- MISC SERVICES ------------------------------ */

export function getAcountOwnerList(body) {
  let url = `${API_URL}/api/account-owner`;
  return new ApiCore().postAuth(url, body);
}

export function getClientCustomerList(id) {
  let url = `${API_URL}/api/get-client-customer?client_id=${id}`;
  return new ApiCore().getAuth(url);
}

export function getCountryOfEmploymentDropdown(clientId, clientCustomerId) {
  let url = `${API_URL}/api/country-of-employment-dropdown?client_id=${clientId}&client_customer_id=${clientCustomerId}`;
  return new ApiCore().getAuth(url);
}

export function getExportData(filters) {
  let url = `${API_URL}/api/export-data?all=1`;
  Object.entries(filters).forEach(([key, value]) => {
    if (value) url += `&${key}=${value}`;
  });
  return new ApiCore().getAuth(url);
}

export function getLogs(empId, usertype, page = 1, perPage = 10, searchName = "", startDate = "", endDate = "", isExport = false) {
  let url = `${API_URL}/api/get-logs?employeeId=${empId}&userType=${usertype}&page=${page}&perPage=${perPage}`;
  
  if (searchName) url += `&searchName=${encodeURIComponent(searchName)}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  if (isExport) url += `&export=true`;

  return new ApiCore().getAuth(url);
}


export function RaiseConcern(body) {
  let url = `${API_URL}/api/raise-action`;
  return new ApiCore().postAuth(url, body);
}

export function getExcelLink() {
  let url = `${API_URL}/api/send-import-link`;
  return new ApiCore().getAuth(url);
}

export function UploadClientBulk(body) {
  let url = `${API_URL}/api/client_bulk_upload`;
  return new ApiCore().postforFormData(url, body);
}

/* ------------------------- NOTIFICATION SERVICES ------------------------- */

export function getAllNotifications() {
  let url = `${API_URL}/api/get-all-notification`;
  return new ApiCore().get(url);
}

// Cheap, poll-friendly badge-count endpoint (single indexed COUNT query on
// the backend) -- added 2026-10-07 for the bell's polling loop so it isn't
// repeating getAllNotifications' full fetch on every tick. Same .get() (no
// auth header) as getAllNotifications, for consistency -- see that
// function's note on why this is intentional, not a gap.
export function getNotificationCount() {
  let url = `${API_URL}/api/get-notification-count`;
  return new ApiCore().get(url);
}

// Lightweight preview (most recent few, newest first) for the bell's
// dropdown panel -- added 2026-10-07. Fetched only when the panel is
// opened, not on every poll tick -- see getNotificationCount for that.
export function getRecentNotifications() {
  let url = `${API_URL}/api/get-recent-notifications`;
  return new ApiCore().get(url);
}

/* ---------------------- BROWSER PUSH NOTIFICATIONS ----------------------- */
// Added 2026-10-07. Separate from everything above -- these back the
// permission-prompt + service-worker subscription flow in
// src/services/pushNotifications.js, not the in-app notification list.

export function getVapidPublicKey() {
  let url = `${API_URL}/api/push/vapid-public-key`;
  return new ApiCore().get(url);
}

export function subscribeToPush(body) {
  let url = `${API_URL}/api/push/subscribe`;
  return new ApiCore().post(url, body);
}

export function unsubscribeFromPush(body) {
  let url = `${API_URL}/api/push/unsubscribe`;
  return new ApiCore().post(url, body);
}

export function sendTestPush(body) {
  let url = `${API_URL}/api/push/test`;
  return new ApiCore().post(url, body);
}

export function markNotificationRead(notif_id) {
  let url = `${API_URL}/api/notification-status-change?notif_id=${notif_id}`;
  return new ApiCore().postAuth(url);
}

/* ----------------------------- INBOX SERVICES ----------------------------- */

export function getAllTickets(filters = {}, page = 1, pageSize = 20) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.append(key, value);
  });
  params.append("page", page);
  params.append("per_page", pageSize);
  let url = `${API_URL}/api/get-all-tickets?${params.toString()}`;
  return new ApiCore().getAuth(url);
}

export function getTicketCount() {
  let url = `${API_URL}/api/get-ticket-count`;
  return new ApiCore().getAuth(url);
}

// Backs the global "new email arrived" toast (Sidebar.js) -- sinceId/
// sinceReplyId are the highest ticket/reply ids already seen; omit/0 for
// the first poll of either series, which just establishes a baseline
// without listing the whole backlog as new.
export function getNewTickets(sinceId, sinceReplyId) {
  let url = `${API_URL}/api/get-new-tickets?since_id=${sinceId || 0}&since_reply_id=${sinceReplyId || 0}`;
  return new ApiCore().getAuth(url);
}

// Backs the Inbox's "Needs Attention" banner -- every open, unassigned,
// high-urgency ticket the requester can see. Confirmed with the user,
// 2026-10-26.
export function getTicketsNeedingAttention() {
  let url = `${API_URL}/api/get-tickets-needing-attention`;
  return new ApiCore().getAuth(url);
}

// Backs the Inbox filter bar's Client Name / Client Location dropdowns --
// only clients/locations that actually have at least one ticket, not
// every client in the system.
export function getTicketFilterOptions() {
  let url = `${API_URL}/api/get-ticket-filter-options`;
  return new ApiCore().getAuth(url);
}

// Internal-user list for the reply composer's To/Cc autosuggest --
// deliberately separate from the admin "get-all-users" endpoint, which
// most inbox-only roles don't have permission for.
export function getUserDirectory() {
  let url = `${API_URL}/api/get-user-directory`;
  return new ApiCore().getAuth(url);
}

// Backs the Inbox's manual "Refresh" button -- forces an immediate poll
// of the shared mailbox instead of waiting for the 2-minute scheduled
// job (scheduler/ticket_inbox_job.py), confirmed with the user,
// 2026-10-28. Same process_inbox() the scheduler calls.
export function syncTicketInbox() {
  let url = `${API_URL}/api/process-ticket-inbox`;
  return new ApiCore().postAuth(url, {});
}

// Powers the Inbox's Outlook-style left sidebar -- "My Tickets" + one
// expandable folder per direct report, nested for multi-level teams.
// Empty tree for an individual contributor with nobody reporting to them.
export function getTicketSidebar() {
  let url = `${API_URL}/api/get-ticket-sidebar`;
  return new ApiCore().getAuth(url);
}

export function updateTicket(ticket_id, body) {
  let url = `${API_URL}/api/update-ticket?ticket_id=${ticket_id}`;
  return new ApiCore().postAuth(url, body);
}

export function bulkUpdateTickets(ticket_ids, body) {
  let url = `${API_URL}/api/bulk-update-tickets`;
  return new ApiCore().postAuth(url, { ticket_ids, ...body });
}

// multipart/form-data now (not JSON) -- attachments need real file
// bytes, so to/cc/bcc travel as JSON-encoded strings in regular form
// fields instead, same convention both reply and compose use.
export function replyToTicket(ticket_id, body, subject, to, cc, bcc, attachments) {
  let url = `${API_URL}/api/reply-ticket`;
  const formData = new FormData();
  formData.append("ticket_id", ticket_id);
  formData.append("body", body);
  formData.append("subject", subject);
  formData.append("to", JSON.stringify(to || []));
  formData.append("cc", JSON.stringify(cc || []));
  formData.append("bcc", JSON.stringify(bcc || []));
  (attachments || []).forEach((file) => formData.append("attachments", file));
  return new ApiCore().postforFormData(url, formData);
}

// "Compose New Email" -- starts a brand-new outbound ticket, as opposed
// to every other ticket, which is auto-created from an inbound email.
export function composeTicket(to, cc, bcc, subject, body, attachments) {
  let url = `${API_URL}/api/compose-ticket`;
  const formData = new FormData();
  formData.append("to", JSON.stringify(to || []));
  formData.append("cc", JSON.stringify(cc || []));
  formData.append("bcc", JSON.stringify(bcc || []));
  formData.append("subject", subject);
  formData.append("body", body);
  (attachments || []).forEach((file) => formData.append("attachments", file));
  return new ApiCore().postforFormData(url, formData);
}

export function getTicketThread(ticket_id) {
  let url = `${API_URL}/api/get-ticket-thread?ticket_id=${ticket_id}`;
  return new ApiCore().getAuth(url);
}

// Bulk mark-all-as-read -- added 2026-10-07 for the redesigned
// notifications page. One request, not a loop of markNotificationRead
// calls -- the backend does this as a single UPDATE statement.
export function markAllNotificationsRead() {
  let url = `${API_URL}/api/notification-mark-all-read`;
  return new ApiCore().postAuth(url);
}


export function getEmployeeAttachments(id) {
  let url = `${API_URL}/api/get-employee-attachments/`;
  return new ApiCore().get(url);
}
